// extracted by mini-css-extract-plugin
export default {"title":"TermsPage_title__hcDE2","item":"TermsPage_item__M0fDQ"};